import { useLocation, useNavigate, } from "react-router-dom";
import { useEffect } from "react";
const isaacjenemann = `${process.env.PUBLIC_URL}/IsaacJenemann.pdf#toolbar`;

function ProjectMenu({ nextImage, prevImage }) {
  const location = useLocation();
  const navigate = useNavigate();
  const isProjectPage = location.pathname.startsWith("/recent/");
  const isResume = location.pathname.startsWith("/resume");

  const handleKeyDown = (event) => {
    if (isProjectPage) {
      if (event.key === "ArrowLeft") {
        prevImage();
      } else if (event.key === "ArrowRight") {
        nextImage();
      } else if (event.key === "Escape") {
        navigate("/recent");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);


    // Cleanup function to remove the event listeners and clear the timer
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isProjectPage, prevImage, nextImage, navigate]); // Dependencies to rerun effect when these change

  return (
    <>
      {isProjectPage && (
        <>
          <a onClick={prevImage} className="project-button" id="prev-project">
            &#8249;
          </a>

          <a className="project-button" id="escape" href="/recent">
            exit
          </a>

          <a onClick={nextImage} className="project-button" id="next-project">
            &#8250;
          </a>
        </>
      )}

      {isResume && (
        <>
          <a
            className="project-button"
            id="escape"
            style={{ justifySelf: "left" }}
            href="/home"
          >
            exit
          </a>
          <a
            href={isaacjenemann}
            target="_blank"
            rel="noreferrer"
            download="ResumeForIsaacJenemann"
            className="project-button"
            id="download"
          >
            download
          </a>
        </>
      )}
    </>
  );
}

export default ProjectMenu;
